import { gsap } from "gsap";
import { ScrollTrigger, ScrollSmoother } from "gsap/all";
import { getHeaderHeight } from "./utility/headerHeight.js";
import { initAnnouncement } from "./announcement.js";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
ScrollTrigger.config({ ignoreMobileResize: true });

const capturedHash =
    window.location.hash && !window.location.hash.includes("/")
        ? window.location.hash
        : null;

if (capturedHash) {
    history.replaceState(
        null,
        "",
        window.location.pathname + window.location.search,
    );
}

window.addEventListener("DOMContentLoaded", () => {
    initAnnouncement();

    const scroller = ScrollSmoother.create({
        smooth: 0.6,
        effects: true,
        // On touch devices the smoother mirrors native scroll onto a transform
        // from the JS thread, which lags a frame behind during momentum scrolls
        // and jitters pinned sections. Normalizing runs the scroll itself on
        // the JS thread so the two stay in sync.
        normalizeScroll: true,
    });

    scroller.refresh();

    if (capturedHash) {
        const scrollElem = document.querySelector(capturedHash);
        if (scrollElem) {
            gsap.delayedCall(0.5, () => {
                scroller.scrollTo(
                    scroller.offset(scrollElem, `top ${getHeaderHeight()}`),
                    true,
                );
                history.replaceState(
                    null,
                    "",
                    window.location.pathname +
                        window.location.search +
                        capturedHash,
                );
            });
        }
    }

    const changeColor = document.querySelector("body.blue") == null;

    const header = document.querySelector("#header");

    if (header) {
        document.addEventListener("scroll", () => {
            const scrolled = window.scrollY > 1;

            if (changeColor) {
                header.classList.toggle("bg-transparentwhite", scrolled);
            }

            header.classList.toggle("backdrop-blur-sm", scrolled);
        });
    }

    gsap.utils.toArray("a.anchor").forEach((button) => {
        button.addEventListener("click", (e) => {
            e.preventDefault();
            const href =
                e.target.getAttribute("href") ??
                e.target.parentNode.getAttribute("href");
            const id = href.includes("#") ? `#${href.split("#")[1]}` : href;

            if (!id) return;

            setTimeout(() => {
                scroller.scrollTo(id, true, `top ${getHeaderHeight()}`);
            }, 200);
        });
    });

    gsap.utils.toArray("a.toc-anchor").forEach((button) => {
        button.addEventListener("click", (e) => {
            e.preventDefault();
            const id =
                e.target.getAttribute("href") ??
                e.target.parentNode.getAttribute("href");

            if (!id) return;

            setTimeout(() => {
                scroller.scrollTo(id, true, `top ${getHeaderHeight()}`);
            }, 200);
        });
    });
});
